const setFristChildrenNationality = (id = null) => {
  return {
    type: 'SET_FRISTCHILDRENNATIONALITY',
    id
  }
}

export default {
  setFristChildrenNationality,
}
